<div id='home-sensors-section-header'>{{trans('systems.titles.sensors')}}</div>
<div id='home-sensors-section-container'>
    <div class="hsc-item" *ngFor='let iSensor of visibleSensors'>
        <div [ngClass]="{ 'hsc-item-name': true, 'hsc-item-name-w': senS.watcherStatus.isWorking }"><div>{{iSensor.name}}</div></div>
        <app-loader-dots-v2 *ngIf='senS.watcherStatus.isWorking'></app-loader-dots-v2>
        <div class="hsc-item-icon" [inlineSVG]="senS.getSensorIcon(iSensor.type)"></div>
        <div class="hsc-item-value">{{iSensor.temperature === '' ? '--' : iSensor.temperature}}{{senS.getSensorIconData(iSensor.type).unit}}</div>
    </div>
</div>